<template>
<v-btn large class="caption" style="flex: 1" @click="handleClick">
  <v-icon>{{ icon }}</v-icon>
  <div class="ml-2" v-show="!$vuetify.breakpoint.xsOnly">
    {{ text }}
  </div>
</v-btn>
</template>
<script>
export default {
  name: "Tab",
  props: ["changeTab", "icon", "text"],
  methods: {
    handleClick() {
      this.$emit("changeTab");
    }
  }
}
</script>